import Crud from './crud'
import { request_list, export_list } from '@/commons/hpod';
import Vue from 'vue';
var FileSaver = require('file-saver');
var crud = new Crud('receipts', 'đơn xuất');

const state = {
    ...crud.state,
    by_products: {},
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getListByProduct({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('receipts/by_product', data => {
            commit('setListByProduct', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    export_excel({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list("receipts", res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            FileSaver.saveAs(blob, `DonXuat_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    },
};
const mutations = {
    ...crud.mutations,
    setListByProduct(state, data) {
        state.by_products = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};